import React  from 'react'
import RefExampleChild from './RefExampleChild';
import RefExampleOtherChild from './RefExampleOtherChild';


export default class RefExample extends React.Component 
{
    static defaultProps={

    };

    constructor(props) 
    {
        super(props);
        this.state = {
        };
        this.callRef = React.createRef();  
          
    }

 
    
    componentDidMount() 
    {
        
    }

    render()
    {
        return (
            <div className='contentwrapper'>
                <div className='border bg-warning p-2 m-2'>
                    <div>
                        <div>This is the RefExample component.</div>
                        
                        <RefExampleChild callRef={this.callRef}/>
                        
                        <RefExampleOtherChild callRef={this.callRef}/>
                        
                        
                    </div> 
                </div> 
            </div>
        );
    }
}

